import { ReactNode } from "react";
import colors from "src/utils/colors";
import { BorderButton } from "../buttons/BorderButton";

interface Props {
  className?: string;
  children: ReactNode;
  closable?: boolean;
  onClose?: () => void;
  onClick?: () => void;
}

export function Tag(props: Props) {
  return (
    <BorderButton bgColor={colors.bgGray} className="cursor-auto">
      <div className="flex items-center">
        <div className="flex-1" onClick={props.onClick}>
          {props.children}
        </div>
        {props.closable && (
          <div className="ml-4 cursor-pointer" onClick={props.onClose}>
            <i aria-hidden className="far fa-xmark text-empty" />
          </div>
        )}
      </div>
    </BorderButton>
  );
}
